<template>
    <div class="row mb-2 input-element">
        <div class="col-12 label" v-html="fieldText"></div>
        <div class="col-12 input">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fieldText: String
    }
}
</script>